import React from 'react';
// import roboMdImg from '../../resources/img/robomd_character.svg'; // 실제 경로로 바꿔주세요

export class RpAutoConfigIntroBySalePrice extends React.Component {
  constructor(props) {
    super(props);
  }

  handleClickAutoConfig = () => {
    // alert('AI자동설정 시작!');
    if (this.props.onClick) {
        this.props.onClick();
    }
  };

  handleClickSetting = (type) => {
    this.props.onClickSettingButton(type);
  };

  render() {
    return (
        // <div id='common-page-wrapper' className="style_guide_v2" style={{width: "100%", height: "100%", position: "absolute"}}>
            <div className="ai_auto_config_wrap">
                <div className="intro-header" style={{display: "none"}}>
                    <div className="intro-title">AI자동설정</div>
                    <div className="intro-desc">
                        모든 카테고리 마다 상품노출과 진열순서를 고객활동 데이터에 맞춰서 자동진열되게 할 수 있어요
                    </div>
                </div>

                <div className="intro-box">
                    <div>
                        <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_robo_250708.svg"} alt="RoboMD" className="intro-character" />
                        <div className="intro-text">
                            <span style={{ fontWeight: '600' }}>AI로보MD가 쇼핑몰에 <span style={{ color: '#0090FF' }}>맞춤 진열설정</span>을 설정해드릴게요</span>
                        </div>
                        <button className="auto-config-btn" onClick={this.handleClickAutoConfig}>
                            AI자동설정하기
                        </button>

                        <div className="card-button-area">
                            <div className="card-button" onClick={() => this.handleClickSetting('1')}>
                                <div className="emoji"><span style={{fontFamily: "Roboto, 'Noto Sans KR', sans-serif"}}>₩</span></div>
                                <div className="text">상품가격 설정</div>
                            </div>
                            <div className="card-button" onClick={() => this.handleClickSetting('2')}>
                                <div className="emoji">📊</div>
                                <div className="text">자동진열 종류 설정</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        // </div>
    );
  }
}